import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import materialSymbolNames from '../../material_symbols.json';
import { shuffled } from '../../utils/oneBit';
import { useInfiniteList } from './useInfiniteList';

// All Material Symbols in a random order (new on every open); more load as the list is scrolled.
function IconPickerDialog({ onSelect, onClose }) {
  const [query, setQuery] = useState('');
  const order = useMemo(() => shuffled(materialSymbolNames), []);

  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const matches = useMemo(() => {
    const q = query.trim().toLowerCase().replace(/\s+/g, '_');
    return order.filter(n => !q || n.includes(q));
  }, [order, query]);
  const { count, hasMore, sentinel } = useInfiniteList(matches.length, 120, query);

  return ReactDOM.createPortal(
    <div className="emoji-overlay" onClick={onClose}>
      <div className="emoji-dialog nn-icon-dialog" onClick={e => e.stopPropagation()} role="dialog" aria-label="Valitse symboli">
        <div className="emoji-head">
          <input className="emoji-search" autoFocus placeholder="Hae symboleja (englanniksi)..." value={query}
            onChange={e => setQuery(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && matches[0] && onSelect(matches[0])} />
          <button type="button" className="emoji-close" onClick={onClose} aria-label="Sulje">
            <span className="material-symbols-outlined" aria-hidden="true">close</span>
          </button>
        </div>
        <div className="nn-icon-grid">
          {!matches.length && <div className="emoji-note">Ei symboleja.</div>}
          {matches.slice(0, count).map(name => (
            <button key={name} type="button" className="nn-icon-btn" title={name} onClick={() => onSelect(name)}>
              <span className="material-symbols-outlined nn-symbol" aria-hidden="true">{name}</span>
              <span className="nn-icon-name">{name}</span>
            </button>
          ))}
          {hasMore && <div ref={sentinel} className="nn-sentinel" />}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default IconPickerDialog;
